import { render, staticRenderFns } from "./alert-modal.vue?vue&type=template&id=5d4b94bc&scoped=true"
import script from "./alert-modal.vue?vue&type=script&lang=js"
export * from "./alert-modal.vue?vue&type=script&lang=js"
import style0 from "./alert-modal.vue?vue&type=style&index=0&id=5d4b94bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4b94bc",
  null
  
)

export default component.exports